import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Gauge from "../../../layouts/Gauge";
import HPI from "../../../layouts/HPI";
import LineChart from "../../../layouts/LineChart";
import { motion } from "framer-motion";
import { floatIn } from "../../../utils/motion";

const DashboardHealth = ({ dataList }) => {
  const building = useSelector((state) => state.building.data);
  const floor = useSelector((state) => state.floor.data);
  const dark = useSelector((state) => state.dark.data);
  const navigate = useNavigate();

  return (
    <>
      {dataList === undefined ? (
        <motion.div
          className="h-50 border-main rounded p-2 dashboard-health d-flex flex-column"
          variants={floatIn}
          initial="hidden"
          whileInView="show"
        >
          <div className="d-flex flex-column align-items-start px-2">
            <p className="dashboard-health-title text-main m-0">
              <p
                className="d-inline p-0 dashboard-health-title"
                style={{
                  fontFamily: "Roboto",
                  fontSize: "26px",
                  fontWeight: 200,
                  color: "#fffff",
                }}
              >
                Health & Safety
              </p>
            </p>

            <p
              className="dashboard-health-lead m-0"
              style={{
                fontFamily: "Roboto",
                fontSize: "18px",
                fontWeight: 300,
                color: "#7695b1",
                fontVariant: "sub",
              }}
            >
              Overall building’s health
            </p>
          </div>
          <div className="dashboard-health-body flex-fill mt-3">
            <div className="col text-center justify-content-center align-items-center d-flex h-100">
              <div class="spinner-border text-primary my-auto" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </motion.div>
      ) : floor ? (
        <motion.div
          className={`h-55 cursor-pointer border-main rounded p-3 dashboard-health d-flex flex-column`}
          variants={floatIn}
          initial="hidden"
          whileInView="show"
          whileHover={{ scale: 0.95 }}
          onClick={() => navigate("/health")}
        >
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column align-items-start px-2">
              <div className="dashboard-health-title text-main m-0">
                {/* <span>85%</span> */}
                <p
                  className="d-inline p-0 dashboard-health-title"
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "26px",
                    fontWeight: 200,
                    color: "#fffff",
                  }}
                >
                  Health & Safety
                </p>
              </div>
              <div
                className="dashboard-health-lead m-0"
                style={{
                  fontFamily: "Roboto",
                  fontSize: "18px",
                  fontWeight: 300,
                  color: "#7695b1",
                  fontVariant: "sub",
                }}
              >
                Overall building's health
              </div>
            </div>
            <div className="">
              <HPI averages={dataList} />
            </div>
          </div>
          <div className="dashboard-health-body flex-fill">
            <div className="row h-20 mt-2 w-100 mx-auto">
              {dataList.gauges.map((gauge, i) => (
                <div
                  className="col-xs-12 col-md-4 col-lg-4 text-center d-flex align-items-center justify-content-start flex-column"
                  key={i}
                >
                  <Gauge
                    data={gauge}
                    className="dashboard-health-title"
                    style={{ maxWidth: "100px", width: "80%" }}
                  />
                </div>
              ))}
            </div>
            <div className="h-50 dashboard-health-title">
              <div className="h-100 text-center dashboard-health-title d-flex">
                {dataList.graphs.map((graph, index) => (
                  <LineChart
                    dataList={graph}
                    dark={dark}
                    aspect={1.6}
                    i={index}
                    key={index}
                  />
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      ) : (
        <motion.div
          className={`h-55 border-main rounded p-3 dashboard-health d-flex flex-column`}
          variants={floatIn}
          initial="hidden"
          whileInView="show"
        >
          <div className="w-100 d-flex justify-content-between align-items-center">
            <div className="d-flex flex-column align-items-start px-2">
              <p className="dashboard-health-title text-main m-0">
                {/* <span>85%</span> */}
                <p
                  className="d-inline p-0 dashboard-health-title"
                  style={{
                    fontFamily: "Roboto",
                    fontSize: "26px",
                    fontWeight: 200,
                    color: "#fffff",
                  }}
                >
                  Health & Safety
                </p>
              </p>
              <p
                className="dashboard-health-lead m-0"
                style={{
                  fontFamily: "Roboto",
                  fontSize: "18px",
                  fontWeight: 300,
                  color: "#7695b1",
                  fontVariant: "sub",
                }}
              >
                Overall building's health
              </p>
            </div>
            <div className="">
              <HPI averages={dataList} />
            </div>
          </div>
          <div className="dashboard-health-body flex-fill">
            <div className="row h-20 mt-2 w-100 mx-auto">
              {dataList.gauges.map((gauge, i) => (
                <div
                  className="col-xs-12 col-md-4 col-lg-4 text-center d-flex align-items-center justify-content-start flex-column"
                  key={i}
                >
                  <Gauge
                    data={gauge}
                    className="dashboard-health-title"
                    style={{ maxWidth: "100px", width: "80%" }}
                  />
                </div>
              ))}
            </div>
            <div className="h-50 dashboard-health-title">
              <div className="h-100 text-center dashboard-health-title d-flex">
                {dataList.graphs.map((graph, index) => (
                  <LineChart
                    dataList={graph}
                    dark={dark}
                    aspect={1.6}
                    i={index}
                    key={index}
                  />
                ))}
              </div>
            </div>
          </div>
        </motion.div>
      )}
    </>
  );
};

export default DashboardHealth;
